import { useUserCheckMutation } from 'app/api/auth';
import { useAlertHook } from 'app/hooks/useAlertHook';
import { useAppSelector } from 'app/store/store';
import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

type ProtectedRouteT = {
  children: ReactNode;
};

const BASE_ROUTE = process.env?.NODE_ENV === 'development' ? '/welcome' : 'https://sputnix-group.ru/solutions/ais';

console.log("BASE_ROUTE", BASE_ROUTE)
export const ProtectedRoute = ({ children }: ProtectedRouteT) => {
  const { addAlert } = useAlertHook();

  const [checkUser, { data: checkUserData, ...checkUserRequest }] = useUserCheckMutation();

  const auth = useAppSelector((state) => state.userSlice.auth);

  useEffect(() => {
    if (!auth) {
      const wasLogin = localStorage.getItem('isLoggedIn');
      const url = wasLogin === 'true' ? window.location.href.split('?')[0] : window.location.href;
      checkUser(url)
        .unwrap()
        .catch((error: Error) => addAlert(error));
    }

    if (auth?.value) {
      localStorage.setItem('isLoggedIn', auth.value.loggedIn.toString());
    }
  }, [auth]);

  if (checkUserRequest.isSuccess && checkUserData?.value?.loggedIn) {
    return <>{children}</>;
  }

  if (checkUserRequest.isSuccess && !checkUserData?.value?.loggedIn) {
    return <Navigate to={'BASE_ROUTE'} />;
  }

  return null;
};
